import React from 'react';
import { Logo } from 'view/atoms';
import { HeaderLanguageSelector } from '../LanguageSelector';

export const HeaderAuth = () => {
  return (
    <>
      <Logo />
      <HeaderLanguageSelector />
    </>
  );
};
